import { ICON_PATH } from '@federa/const/icon-svg-paths';
import { createIcon } from '../createIcon.tsx';

export const UsersIcon = createIcon(
	'UsersIcon',
	<>
		<path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
		<circle cx="9" cy="7" r="4" />
		<path d="M23 21v-2a4 4 0 0 0-3-3.87" />
		<path d={ICON_PATH.SECOND_PERSON_HEAD_ARC} />
	</>,
);
